import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

// 컬렉션 이미지 리스트 페이지 상단에 보여줄 컬렉션 이름 불러오기
async function getCollectionName(id?: number): Promise<AxiosResponse<FetchResult<{ name: string }>>> {
  const response = await instance.get(`/collections/${id}/name`);
  return response;
}

const useFetchCollectionName = (id?: number) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/collections/${id}/name`],
    queryFn: () => getCollectionName(id),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(id)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchCollectionName;
